export default "__VITE_ASSET__Re38AUyB__"